<template>
  <v-container>
    <h1 class="text-center">Live-Ankündigungen</h1>
    <v-row>
      <v-col cols="12">
        <v-switch
          v-model="enabled"
          label="Ankündigung aktiviert"
        ></v-switch>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          :items="channels"
          item-text="name"
          item-value="id"
          label="Discord-Kanal"
          v-model="channelId"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-textarea
          label="Nachricht"
          hint="Platzhalter: {streamer}, {titel}, {spiel}, {url}. Darunter erscheint automatisch eine Vorschau-Kachel (Titel, Spiel, Zuschauerzahl, Stream-Vorschaubild) im Stil von Streamcord."
          persistent-hint
          v-model="message"
        ></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn color="primary" :block="$vuetify.breakpoint.smAndDown" @click="saveValues">Speichern</v-btn>
        <v-btn
          :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : 'ml-2'"
          :block="$vuetify.breakpoint.smAndDown"
          outlined
          :disabled="!channelId"
          :loading="sendingTest"
          @click="sendTest"
        >
          Testnachricht senden
        </v-btn>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="settingsSaved"
      timeout="3000"
      color="green"
    >
      Einstellungen gespeichert!
    </v-snackbar>
    <v-snackbar
      v-model="testResult.show"
      timeout="5000"
      :color="testResult.success ? 'green' : 'red'"
    >
      {{ testResult.message }}
    </v-snackbar>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      settingsSaved: false,
      enabled: false,
      channelId: null,
      message: '',
      channels: [],
      sendingTest: false,
      testResult: {
        show: false,
        success: false,
        message: '',
      },
    };
  },
  mounted() {
    BackendService.loadLiveAnnouncementSettings().then((data) => {
      this.enabled = Number(data.data.settings.live_announce_enabled) === 1;
      this.channelId = data.data.settings.live_announce_channel_id;
      this.message = data.data.settings.live_announce_message || '';
      this.channels = data.data.channels;
    });
  },
  methods: {
    saveValues() {
      BackendService.saveLiveAnnouncementSettings({
        live_announce_enabled: this.enabled ? 1 : 0,
        live_announce_channel_id: this.channelId,
        live_announce_message: this.message,
      }).then(() => {
        this.settingsSaved = true;
      }).catch(() => {
        alert('nö!');
      });
    },
    sendTest() {
      this.sendingTest = true;
      BackendService.sendTestLiveAnnouncement({
        live_announce_channel_id: this.channelId,
        live_announce_message: this.message,
      }).then((data) => {
        this.testResult = {
          show: true,
          success: data.data.success,
          message: data.data.success
            ? 'Testnachricht wurde gesendet! Schau in den Discord-Kanal.'
            : `Fehlgeschlagen: ${data.data.error}`,
        };
      }).catch(() => {
        this.testResult = {
          show: true,
          success: false,
          message: 'Fehlgeschlagen: Verbindung zum Server nicht möglich.',
        };
      }).finally(() => {
        this.sendingTest = false;
      });
    },
  },
};
</script>
